import axios from "axios";
import { z } from "zod";
import { environment } from "../environment";
import { errorLog } from "../logger";
import ValidationError from "./ZodError";
const ResponseBodyMulti = z.object({
    status: z.boolean(),
    message: z.string(),
    user_id: z.string(),
    cognito_AccessToken: z.string(),
    user_year: z.string(),
    custodian: z.literal("multi"),
});
const ResponseBodyApex = z.object({
    status: z.boolean(),
    message: z.string(),
    user_id: z.number(),
    cognito_AccessToken: z.string(),
    user_year: z.string(),
    custodian: z.literal("apex"),
});
const ResponseBody = z.union([ResponseBodyMulti, ResponseBodyApex]);
export const url = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/flask/fartherfinance/v1/user/login"
    : "https://middleware.uat.farther.com/flask/fartherfinance/v1/user/login";
export default async function login(magicToken, clientEmail, metadata) {
    const res = await axios.post(url(), {
        metadata: metadata,
        payload: {
            email: clientEmail,
            password: "password",
        },
    }, {
        headers: {
            Authentication: magicToken,
            "Content-Type": "application/json;charset=UTF-8",
        },
    });
    const decoded = ResponseBody.safeParse(res.data);
    if (decoded.success) {
        const data = decoded.data;
        const jwt = data.cognito_AccessToken;
        const userId = data.custodian === "multi" ? data.user_id : `${data.user_id}`;
        return { jwt, userId, custodian: data.custodian };
    }
    else {
        const errorMessage = "Could not decode login response";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=login.js.map